import React, { useEffect } from 'react'

const TestMarketPlace = () => {
    useEffect(() => {
        const token = new URLSearchParams(window.location.search).get('token');
        const allParams = new URLSearchParams(window.location.search).getAll('token');
        console.log(allParams);
        if (allParams.length > 0) {
            localStorage.setItem('marketplace_token2', allParams.join(','));
            window.location.href = '/signin';
        }
        if (token) {
          // Salva il token temporaneamente (es. in localStorage o cookie)
          localStorage.setItem('marketplace_token', token);
          // Reindirizza alla registrazione
          window.location.href = '/signin';
        }
      }, []);
  return (
    <div>
        <h1>TestMarketPlace</h1>
    </div>
  )
}

export default TestMarketPlace